import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/cms/typescript';
import theme from '@styles/theme';
export default {
  categoryLabelContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  },
  headingWrapper: (bg: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes, isPromoVariant: boolean) => {
    const backgroundColor = isPromoVariant ? theme.rawColors.accent700 : bg;
    return {
      backgroundColor,
      p: isPromoVariant ? ['9.03px 24px 5.42px 24px', '9.03px 24px 5.42px 24px', '9.03px 40px 5.42px 40px', '9.03px 40px 5.42px 40px', '9.03px 24px 5.42px 24px'] : '0',
      mt: MARGINS_BLOCKS[marginTop],
      mb: MARGINS_BLOCKS[marginBottom],
      position: 'relative',
      zIndex: theme.zIndex.documentUp
    };
  }
};